import { Flex, Text } from "@radix-ui/themes";
import LocationGreenIcon from "@/assets/icons/location_green.svg?react";

type LocationBadgeProps = {
  city: string;
  country?: string | null;
  color?: string;
};

export default function LocationBadge({
  city,
  country,
  color = "#1B5843",
}: LocationBadgeProps) {
  return (
    <Flex
      className={`items-center gap-[2px] rounded-[4px] w-fit py-1 px-2 bg-white`}
    >
      <div
        className="flex items-center justify-center flex-shrink-0 w-[16px] h-[16px]"
        style={{ color }}
      >
        <LocationGreenIcon
          width={18}
          height={18}
          className="[&>path]:fill-current"
          style={{ color }}
        />
      </div>
      <Text className="text-[12px] font-semibold self-center" style={{ color }}>
        {city}
        {country && `, ${country}`}
      </Text>
    </Flex>
  );
}
